var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5092 23.855V7.6709H0.472046L13.5092 23.855Z",
    fill: "url(#paint0_linear_8489_34089)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5094 23.8545V7.67041H26.5465L13.5094 23.8545Z",
    fill: "url(#paint1_linear_8489_34089)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5464 7.6705H9.46326L13.9588 0.477539H22.0509L26.5464 7.6705Z",
    fill: "url(#paint2_linear_8489_34089)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5553 7.6705H0.472046L4.96761 0.477539H13.0596L17.5553 7.6705Z",
    fill: "url(#paint3_linear_8489_34089)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7347 23L1 8H24L12.7347 23Z",
    fill: "url(#paint4_linear_8489_34089)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8H0L5.00003 0H20L25 8Z",
    fill: "url(#paint5_linear_8489_34089)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5093 24.3044C13.3744 24.3044 13.2395 24.2595 13.1496 24.1246L0.112398 7.94052C0.0224693 7.80565 -0.0224689 7.62585 0.0674602 7.44599C0.157389 7.31112 0.292257 7.22119 0.472062 7.22119H26.5464C26.7262 7.22119 26.8611 7.31112 26.951 7.49093C27.0409 7.67073 26.9959 7.85059 26.9061 7.98546L13.8689 24.1695C13.779 24.2595 13.6441 24.3044 13.5093 24.3044ZM1.41613 8.12032L13.5093 23.1355L25.6024 8.12032H1.41613Z",
    fill: "url(#paint6_linear_8489_34089)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5464 8.12036H0.472049C0.292243 8.12036 0.157376 8.03043 0.0674468 7.89556C-0.0224823 7.7607 -0.0224823 7.58089 0.0674468 7.44602L4.56301 0.253117C4.65294 0.118249 4.83274 0.0283203 4.96761 0.0283203H22.0508C22.1857 0.0283203 22.3655 0.118249 22.4105 0.253117L26.906 7.44602C26.996 7.58089 26.996 7.7607 26.906 7.89556C26.8611 8.03043 26.7262 8.12036 26.5464 8.12036ZM1.28125 7.22123H25.7372L21.7811 0.927454H5.23734L1.28125 7.22123Z",
    fill: "url(#paint7_linear_8489_34089)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5091 24.3043C13.3293 24.3043 13.1495 24.1694 13.1045 23.9896L4.5629 0.612563C4.47297 0.387767 4.5629 0.163023 4.83263 0.0730938C5.05743 -0.0168353 5.32716 0.118032 5.41704 0.342828L13.9587 23.7199C14.0486 23.9447 13.9137 24.2144 13.6889 24.3043C13.599 24.3043 13.5541 24.3043 13.5091 24.3043Z",
    fill: "url(#paint8_linear_8489_34089)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5092 23.8547C13.4643 23.8547 13.4193 23.8547 13.3743 23.8098C13.1495 23.7198 13.0147 23.4501 13.1046 23.2254L21.6462 0.297907C21.7361 0.0731101 22.0058 -0.0617572 22.2306 0.028172C22.4553 0.118101 22.5902 0.387836 22.5003 0.61258L13.9587 23.54C13.8688 23.7648 13.689 23.8547 13.5092 23.8547Z",
    fill: "url(#paint9_linear_8489_34089)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.665 8.12C7.57507 8.12 7.4852 8.07507 7.39527 8.03007C7.21546 7.89521 7.17047 7.58053 7.35033 7.40068L13.1946 0.207769C13.3294 0.0279638 13.6441 -0.017027 13.824 0.162831C14.0038 0.297699 14.0488 0.612371 13.8689 0.79223L8.02467 7.98514C7.93474 8.07507 7.79987 8.12 7.665 8.12Z",
    fill: "url(#paint10_linear_8489_34089)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3535 8.12027C19.2186 8.12027 19.0838 8.07534 18.9938 7.94047L13.1496 0.747508C13.0147 0.567702 13.0147 0.252977 13.1945 0.11811C13.3743 -0.0167577 13.6891 -0.0167578 13.8239 0.163048L19.6682 7.35596C19.803 7.53576 19.803 7.85049 19.6232 7.98535C19.5333 8.07534 19.4434 8.12027 19.3535 8.12027Z",
    fill: "url(#paint11_linear_8489_34089)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8489_34089",
    x1: 0.207062,
    y1: 15.7629,
    x2: 15.3286,
    y2: 15.5119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#63FEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3EEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8489_34089",
    x1: 13.5094,
    y1: 15.7625,
    x2: 26.5465,
    y2: 15.7625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8489_34089",
    x1: 9.46326,
    y1: 4.07402,
    x2: 26.5464,
    y2: 4.07402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8489_34089",
    x1: 0.124826,
    y1: 4.07402,
    x2: 19.8973,
    y2: 3.10611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#63FEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3EEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8489_34089",
    x1: 1,
    y1: 15.5,
    x2: 24,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8489_34089",
    x1: 0,
    y1: 4,
    x2: 25,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6700FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8489_34089",
    x1: 0.0184326,
    y1: 15.7628,
    x2: 27,
    y2: 15.7628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8489_34089",
    x1: 0,
    y1: 4.07434,
    x2: 26.9735,
    y2: 4.07434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8489_34089",
    x1: 4.52917,
    y1: 12.1746,
    x2: 13.9868,
    y2: 12.1746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8489_34089",
    x1: 13.0764,
    y1: 11.9274,
    x2: 22.5285,
    y2: 11.9274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8489_34089",
    x1: 7.23584,
    y1: 4.08417,
    x2: 13.9834,
    y2: 4.08417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8489_34089",
    x1: 13.0535,
    y1: 4.07112,
    x2: 19.7643,
    y2: 4.07112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondSelectedIcon);
export default __webpack_public_path__ + "static/media/DiamondSelectedIcon.7bfdd4859eb0decb02ca96e2a90ae94d.svg";
export { ForwardRef as ReactComponent };